<template>
    <div class="service-ctn">
        <hc-menu collapse router :default-active="$route.path">
            <hc-menu-item
                v-for="tab in tabs"
                :key="tab.name"
                :disabled="tab.meta.disabled"
                :index="`${baseRoute}/${tab.path}`"
                :class="{'is-active': isRouteActive(tab)}"
            >
                <svg-icon v-if="!isRouteActive(tab)" :name="tab.meta.iconName" />
                <svg-icon v-else :name="`${tab.meta.iconName}-active`" />

                <p>{{ tab.meta.title }}</p>
            </hc-menu-item>
        </hc-menu>
        <div class="service-ctn__content">
            <Breadcrumb />
            <div class="service-ctn__content__ctn">
                <router-view />
            </div>
        </div>
    </div>
</template>
<script>
import NavMinxin from '../mixins/left-nav'

export default {
    name: 'ServiceEntry',
    mixins: [NavMinxin],
    data() {
        return {
            routeName: 'service',
        }
    },
}
</script>

<style lang="less" scoped>
.service-ctn {
    height: 100%;
    display: flex;
    &__content {
        flex: 1;
        display: flex;
        overflow-x: auto;
        flex-direction: column;
        background: rgb(245, 247, 251);
        &__ctn {
            flex: 1;
            overflow-y: auto;
        }
    }
}
</style>
